import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import cc from "../../../assets/images/cc.png";

const OfferingParkingAlert = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="24x7 Surveillance"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Offerings" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="24x7 Surveillance @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/data-insights"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary Section */}
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
            <div className="md:w-1/2">
              <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
                Summary
              </h4>
              <p className="text-black mb-4 text-lg">
                HD cameras provide continuous 24x7 monitoring, ensuring enhanced security across smart city infrastructure. These surveillance systems are designed to record incidents in high detail, enabling quick response and post-event analysis.
              </p>
              <p className="text-black text-lg">
                From traffic intersections to public spaces, 24x7 surveillance helps deter crime, monitor behavior, and improve public safety outcomes.
              </p>
            </div>

            <div className="md:w-1/2">
              <img
                src={cc}
                alt="24x7 Surveillance"
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
          </div>

          {/* Introduction Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <p className="text-black mb-4 text-lg">
              Urban environments demand constant vigilance to maintain safety and order. 24x7 Surveillance systems utilize high-definition cameras, real-time data transmission, and video analytics to provide round-the-clock coverage of critical areas.
            </p>
            <p className="text-black text-lg">
              These technologies support law enforcement, traffic control, and emergency response teams by delivering visual intelligence exactly when and where it’s needed.
            </p>
          </div>

          {/* Key Features Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of 24x7 Surveillance:
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black">
              <li><strong>HD Video Quality:</strong> Clear imaging even in low-light conditions</li>
              <li><strong>Night Vision Capability:</strong> Infrared and low-lux sensors for nighttime monitoring</li>
              <li><strong>Cloud-Based Storage:</strong> Secure and scalable video archiving</li>
              <li><strong>Motion Detection:</strong> Triggers alerts for unusual activity</li>
              <li><strong>Remote Access:</strong> Real-time viewing from any device</li>
              <li><strong>AI-Powered Analytics:</strong> Object recognition, license plate reading, and behavior detection</li>
            </ul>
          </div>

          {/* Operational Benefits Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Operational Benefits
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Reduced response time to incidents</li>
              <li>Enhanced situational awareness for authorities</li>
              <li>Evidence collection for investigations and legal use</li>
              <li>Prevention of unauthorized access or activities</li>
              <li>Improved traffic management and public space monitoring</li>
              <li>24x7 peace of mind for stakeholders and citizens</li>
            </ul>
          </div>

          {/* Implementation Considerations */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Implementation Considerations
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Strategic camera placement for wide and overlapping coverage</li>
              <li>Network infrastructure to support high-bandwidth video feeds</li>
              <li>Power backup systems for uninterrupted operation</li>
              <li>Data privacy compliance and retention policies</li>
              <li>Integration with city command-and-control centers</li>
              <li>Training for operators and emergency teams</li>
            </ul>
          </div>

          {/* Ajeevi's Contribution Section */}
          <div>
            <h5 className="text-xl font-semibold mb-3 text-black">
              Ajeevi's 24x7 Surveillance Solutions
            </h5>
            <p className="text-black mb-4 text-lg">
              Ajeevi’s surveillance platform delivers continuous monitoring with advanced technologies:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li><strong>High-Definition Cameras:</strong> Real-time visuals with zoom and pan features</li>
              <li><strong>Smart Video Analytics:</strong> Automated detection of incidents and anomalies</li>
              <li><strong>Edge & Cloud Storage:</strong> Redundant and secure video data storage</li>
              <li><strong>Unified Command Dashboard:</strong> Centralized monitoring and alert system</li>
              <li><strong>Scalable Deployment:</strong> Easily integrable across cities and zones</li>
            </ul>
            <p className="text-black text-lg">
              Explore how Ajeevi’s 24x7 Surveillance offerings can improve safety and visibility across your infrastructure. Visit{" "}
              <a
                href="http://www.ajeevi.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                www.ajeevi.com
              </a>{" "}
              for more details.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferingParkingAlert;
